import React from 'react';
import {
  Fade,
} from '@material-ui/core';
import { TableFadeProps } from './table-fade-props';

export const TableFade: React.FC<TableFadeProps> = (props) => {
  const {
    index = 1,
    pageSize = 20,
    children,
    customDelay,
    ...rest
  } = props;

  const delay = customDelay || index * pageSize;

  return (
    <Fade
      {...rest}
      in
      style={{ transitionDelay: `${delay}ms` }}
      onEntered={(node: HTMLElement) => {
        node.style.removeProperty('transition');
      }}
    >
      {children}
    </Fade>
  );
};
